<template>
  <div>

    <!--
    <v-layout>
      <v-flex xs6>
        item Source
      </v-flex>
      <v-flex xs6>
        Stripped Items
      </v-flex>
    </v-layout>
    <t-string-diff :string1="itemsSource" :string2="strippedItems">

    </t-string-diff>
    -->


    <v-row class="crx-toolbar pa-3 title">
      Used in Recipes
    </v-row>

    <!-- TOOLBAR -->
    <div style="min-height: 56px;">
      <transition
      name="slide-x-reverse-transition"
      mode="out-in">

        <!-- ITEMS -->
        <div 
        v-if="selectedCount === 0"
        key="1"
        class="c-flex-r align-center subheading">

          <!-- select menu -->
          <v-menu offset-y>
            <template v-slot:activator="{ on }">
              <v-btn
                icon
                v-on="on"
              >
                <v-icon>mdi-check-box-multiple-outline</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item
              @click="selectPage">
                <v-list-item-title>Select page</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>

          <v-btn
          text
          class="mr-2"
          :loading="newLoading"
          @click="newBuild">
            <v-icon>add</v-icon>
            <div class="ml-1">
              New Build
            </div>
          </v-btn>

          <v-menu offset-y :close-on-content-click="false" min-width="280px">
            <template v-slot:activator="{ on }">
              <v-btn
                text
                v-on="on"
              >
                <v-icon small>mdi-filter</v-icon>
                <div class="ml-1">
                  Filter
                </div>
                <span v-if="activeFilterCount > 0">
                  &nbsp;|&nbsp;
                  <span class="color1--text">
                    {{ activeFilterCount }}
                  </span>
                </span>
                <v-icon small>mdi-menu-down</v-icon>
              </v-btn>
            </template>
            <v-card class="">
              <v-layout justify-center align-center class="backgroundCard pa-2">
                <v-btn outlined small @click="clearFilters">
                  Clear
                </v-btn>
                <v-spacer></v-spacer>
                Filters
                <v-spacer></v-spacer>
                <v-btn color="color1" class="white--text" small>
                  Accept
                </v-btn>
              </v-layout>
              <div class="c-hr"></div>
              <v-layout class="pl-2 pt-2 pb-2 font-weight-bold unselectable cursor-pointer" @click="filters.active.customer = !filters.active.customer">
                <v-icon small v-if="filters.active.customer" color="color1">
                  mdi-checkbox-marked-outline
                </v-icon>
                <v-icon small v-else>
                  mdi-checkbox-blank-outline
                </v-icon>
                &nbsp;
                Customer:
              </v-layout>
              <div class="c-hr"></div>
              <v-expand-transition>
                <div v-show="filters.active.customer">
                  <div style="background: #f7fafc;" class="pt-1 pb-1">
                  </div>
                </div>
              </v-expand-transition>

              <div class="c-hr"></div>
              <v-layout class="pl-2 pt-2 pb-2 font-weight-bold unselectable cursor-pointer" @click="filters.active.date = !filters.active.date">
                <v-icon small v-if="filters.active.date" color="color1">
                  mdi-checkbox-marked-outline
                </v-icon>
                <v-icon small v-else>
                  mdi-checkbox-blank-outline
                </v-icon>
                &nbsp;
                Date:
              </v-layout>
              <div class="c-hr"></div>
              <v-expand-transition>
                <div v-show="filters.active.date">
                  <div style="background: #f7fafc;" class="pt-1 pb-1">
                    <v-select
                      v-model="filters.date.mainSelect"
                      class="ma-2 input-slot-thin-border caption"
                      :items="dateFilters"
                      dense
                      hide-details
                      solo
                    ></v-select>
                    <!-- DATE OPTIONS -->
                    <div v-if="filters.date.mainSelect === 'is in the last'">
                      <v-layout class="pl-2 pr-2" style="width: 12em;">
                          <v-icon small color="color1">mdi-subdirectory-arrow-right</v-icon>
                          &nbsp;
                          <c-input :value.sync="filters.date.isInTheLast_input" class="crx-box-input mr-2" style="flex: 0 0 3em;"></c-input>
      
                          <v-select
                            v-model="filters.date.isInTheLast_select"
                            class="input-slot-thin-border caption"
                            style="flex: 0 0 5em;"
                            :items="['days', 'months']"
                            dense
                            hide-details
                            solo
                          ></v-select>
                      
                      </v-layout>
                    </div>
                    <div v-else-if="filters.date.mainSelect === 'is equal to'">
                      <v-layout class="pl-2 pr-2" align-center>
                        <v-icon small color="color1">mdi-subdirectory-arrow-right</v-icon>
                        &nbsp;
                        <c-date :date.sync="filters.date.date1" class="crx-box-input caption" style="background: white;flex: 0 0 12em;"></c-date>
                      </v-layout>
                    </div>
                    <div v-else-if="filters.date.mainSelect === 'is between'">
                      <v-layout class="pl-2 pr-2" align-center>
                        <v-icon small color="color1">mdi-subdirectory-arrow-right</v-icon>
                        &nbsp;
                        <c-date :date.sync="filters.date.date1" class="ma-2 crx-box-input caption" style="background: white;flex: 0 0 12em;"></c-date>
                        and
                        <c-date :date.sync="filters.date.date2" class="ma-2 crx-box-input caption" style="background: white;flex: 0 0 12em;"></c-date>
                      </v-layout>
                    </div>
                    <div v-else-if="filters.date.mainSelect === 'is after'" class="">
                      <v-layout class="pl-2 pr-2" align-center>
                        <v-icon small color="color1">mdi-subdirectory-arrow-right</v-icon>
                        &nbsp;
                        <c-date :date.sync="filters.date.date1" class="crx-box-input caption" style="background: white;flex: 0 0 12em;"></c-date>
                      </v-layout>
                    </div>
                    <div v-else-if="filters.date.mainSelect === 'is on or after'" class="">
                      <v-layout class="pl-2 pr-2" align-center>
                        <v-icon small color="color1">mdi-subdirectory-arrow-right</v-icon>
                        &nbsp;
                        <c-date :date.sync="filters.date.date1" class="crx-box-input caption" style="background: white;flex: 0 0 12em;"></c-date>
                      </v-layout>
                    </div>
                    <div v-else-if="filters.date.mainSelect === 'is before'" class="">
                      <v-layout class="pl-2 pr-2" align-center>
                        <v-icon small color="color1">mdi-subdirectory-arrow-right</v-icon>
                        &nbsp;
                        <c-date :date.sync="filters.date.date1" class="crx-box-input caption" style="background: white;flex: 0 0 12em;"></c-date>
                      </v-layout>
                    </div>
                    <div v-else-if="filters.date.mainSelect === 'is on or before'" class="">
                      <v-layout class="pl-2 pr-2" align-center>
                        <v-icon small color="color1">mdi-subdirectory-arrow-right</v-icon>
                        &nbsp;
                        <c-date :date.sync="filters.date.date1" class="crx-box-input caption" style="background: white;flex: 0 0 12em;"></c-date>
                      </v-layout>
                    </div>
                    
                  </div>
                </div>
              </v-expand-transition>
              <!-- deleted -->
              <v-layout class="pl-2 pt-2 pb-2 font-weight-bold unselectable cursor-pointer" @click="filters.active.deleted = !filters.active.deleted">
                <v-icon small v-if="filters.active.deleted" color="color1">
                  mdi-checkbox-marked-outline
                </v-icon>
                <v-icon small v-else>
                  mdi-checkbox-blank-outline
                </v-icon>
                &nbsp;
                Deleted:
              </v-layout>
              <div class="c-hr"></div>
              <v-expand-transition>
                <div v-show="filters.active.deleted">
                  <div style="background: #f7fafc;" class="pt-1 pb-1">
                    <v-row class="align-center pa-2">
                      <span class="label">
                        Showing deleted builds
                      </span>
                    </v-row>
                  </div>
                </div>
              </v-expand-transition>
              <!-- end deleted -->
            </v-card>
          </v-menu>

        </div>

        <!-- selected count -->
        <div v-if="selectedCount > 0"
        key="2"
        class="c-flex-r align-center subheading">
          <v-btn
          icon
          class=""
          @click="selected = {}">
            <v-icon color="color1">close</v-icon>
          </v-btn>
          <div class="text-sans font-weight-bold">
            <span>&nbsp;{{ selectedCount }}</span>
            selected 
          </div>
          <v-spacer v-if="$vuetify.breakpoint.xs"></v-spacer>
          <span class="icon--text ml-2">|</span>

          <!-- select menu -->

          <v-btn 
          icon
          @click="onDelete">
            <v-icon>delete_outline</v-icon>
          </v-btn>
          <!-- select menu -->
          <v-menu offset-y>
            <template v-slot:activator="{ on }">
              <v-btn
                icon
                v-on="on"
              >
                <v-icon>mdi-check-box-multiple-outline</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item
              @click="selectPage">
                <v-list-item-title>Select page</v-list-item-title>
              </v-list-item>
              <v-list-item
              @click="selectNone">
                <v-list-item-title>Select none</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </div>

      </transition>
    </div>
    <!-- !TOOLBAR -->

    <list-row
    v-for="item in items" 
    :key="item.id"
    :item="item"
    :itemsMeta="itemsMeta"
    :selected="selected"
    :selectedCount="selectedCount"
    :searchFilters="filters.search"
    @checkRow="checkRow(item)"
    @click.native="clickRow(item)"
    @onDelete="deleteCallback"
    ></list-row>

      <!-- BOTTOM TOOLBAR -->
      <div class="border-t--thin">

        <!-- PAGINATION -->
        <c-pagination
        compact
        :page="page"
        :pagination="pagination"
        :filters="filters"
        @updatePageNumber="updatePageNumber"
        @goToFirstPage="goToFirstPage"
        @goToPreviousPage="goToPreviousPage"
        @goToNextPage="goToNextPage"
        @goToLastPage="goToLastPage"
        ></c-pagination>
        <!-- PAGINATION -->

      </div>
      <!-- !BOTTOM TOOLBAR -->
  </div>
</template>

<script>
import ListRow from '../builds/BuildCard'
import ServerListController from '@/mixins/ServerListController'
import ServerListBindings from '@/mixins/ServerListBindings'
import CSListItemsPerPage from '@/components/list-server/C-SListItemsPerPage'

export default {
  props: ['id'],
  mixins: [ServerListController, ServerListBindings],
  components: {
    ListRow,
    CSListItemsPerPage
  },
  data () {
    return {
      newLoading: false,
      filters: {
        rowsPerPage: 9,
        sortCol: 'name_inventory_item',
        sortAscending: true,
        date: {
          mainSelect: 'is equal to',
          isInTheLast_select: 'days',
          isInTheLast_input: null,
          date1: null,
          date2: null,
        },
        search: {
          id: '',
          name_inventory_item: '',
          name_build: '',
        },
        active: {
          customer: false,
          date: false,
          deleted: false
        },
        categories: []
      },
      dateFilters: ['is in the last', 'is equal to', 'is between', 'is after', 'is on or after', 'is before', 'is on or before'],
      page: 0,
      itemsMeta: {
        newID: null // this will be set to the newst created row
      }
    }
  },
  computed: {
  },
  methods: {
    clickRow (build) {
      if (this.selectedCount > 0) {
        this.checkRow(build)
      } else {
        this.$router.push('/inventory/inventory-definition/build/' + build.id)
      }
    },
    newBuild () {
      var data = {
          inventoryItemID: this.id
        }
      this.$axios.post('product-builds/new',
        data,
        {headers: {'Content-Type': 'application/json'}})
        .then(response => {
          this.itemsMeta.newID = response.data.id
          console.log(this.itemsMeta.newID)
          this.page = 0
          this.filters.sortCol = 'id'
          this.filters.sortAscending = false
          Object.keys(this.filters.active).forEach(key => {
            this.filters.active[key] = false
          })
          Object.keys(this.filters.search).forEach(key => {
            this.filters.search[key] = ''
          })
          this.loadAPI()
        })
        .catch(error => this.$root.$errorSnackbar(error))
    },
    /*
    newBuild () {
      this.newLoading = true
      this.$axios.post('product-builds/new',
        {
          inventoryItemID: this.id
        },
        {headers: {'Content-Type': 'application/json'}})
        .then(response => {
          this.$store.dispatch('db/productBuilds/addBuilds', [{...response.data}])
          this.items.push({...response.data})
          console.log(response)
        })
        .catch(error => this.$root.$errorSnackbar(error))
        .then(() => {
          this.newLoading = false
        })
    },*/
    deleteCallback (id) {
      this.$axios.post('product-builds/delete', [id],
        {headers: {'X-Requested-With': 'XMLHttpRequest'}})
        .then(response => {
          this.selected = {} // This MUST be done after a successfull delete
          this.page = 0
          this.loadAPI()
        })
        .catch(error => this.$root.$errorSnackbar(error))
    },
    onDelete () {
      var idArray = this.getSelectedRows()
      var title = 'Delete ' + idArray.length + ' build' + (idArray.length === 1 ? '' : 's') + '?'
      this.$root.$confirm(title, 'Are you sure?', { color: 'purple' }).then((confirm) => {
        if (confirm) {
          this.$axios.post('product-builds/delete', idArray,
            {headers: {'X-Requested-With': 'XMLHttpRequest'}})
            .then(response => {
              this.selected = {} // This MUST be done after a successfull delete
              this.page = 0
              this.loadAPI()
            })
            .catch(error => this.$root.$errorSnackbar(error))
        }
      })
    },
    loadAPI: _.debounce(function (e) {
      return new Promise((resolve, reject) => {
        const encodedFilters = btoa(JSON.stringify(this.filters))
        this.$axios.get(`/product-builds/builds-using-item/${this.id}?filters=${encodedFilters}&page=${this.page}`)
          .then(response => {
            var rows = response.data.rows
            this.pagination.rowCount = response.data.count
            this.pagination.pages = Math.ceil(this.pagination.rowCount / this.filters.rowsPerPage)
            this.items = rows
            resolve(response.data)
          })
          .catch(error => {
            console.log(error)
            this.$root.$errorSnackbar(error)
            reject(error)
          })
      })
    }, 150, {leading: true})
  },
  mounted () {
    this.loadAPI()
  },
  watch: {
    id (nv) {
      this.loadAPI()
    }
  }
}
</script>
